import { Observable as o } from "@microsoft/fast-element";
class n {
  constructor(e, t, s) {
    this._propertyNames = e, this._condition = t, this._styles = s;
  }
  addedCallback(e) {
    const t = o.getNotifier(e.source);
    for (const s of this._propertyNames)
      t.subscribe(this, s);
    this.handleChange(e.source);
  }
  removedCallback(e) {
    const t = o.getNotifier(e.source);
    for (const s of this._propertyNames)
      t.unsubscribe(this, s);
    e.removeStyles(this._styles);
  }
  handleChange(e) {
    this._condition(e) ? e.$fastController.addStyles(this._styles) : e.$fastController.removeStyles(this._styles);
  }
}
export {
  n as PropertiesStylesheetBehavior
};
